import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PROJECT_KEY } from './constants';
import { moveTask } from './projects';
import type { MoveTaskPayload } from './projects.types';

interface MoveTaskVariables {
  projectId: number;
  taskId: number;
  payload: MoveTaskPayload;
}

export const useMoveTask = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ projectId, taskId, payload }: MoveTaskVariables) =>
      moveTask(projectId, taskId, payload),
    onSuccess: (_, { projectId }) => {
      queryClient.invalidateQueries({ queryKey: [PROJECT_KEY, projectId] });
    },
  });
};
